export const userInputs = [
  {
    id: "username",
    label: "Name and surname",
    type: "text",
    placeholder: "Jack Reacher",
  },
  {
    id: "email",
    label: "Email",
    type: "mail",
    placeholder: "reacher92@gmail.com",
  },
  {
    id: "password",
    label: "Password",
    type: "password",
    placeholder: "**********",
  },
  {
    id: "phone",
    label: "Phone",
    type: "text",
    placeholder: "+91 XXXX XXXX XX",
  },

  {
    id: "country",
    label: "Country",
    type: "text",
    placeholder: "India",
  },
  {
    id: "city",
    label: "City",
    type: "text",
    placeholder: "Kurukshetra",
  },
  {
    id: "address",
    label: "Address",
    type: "text",
    placeholder: "1007 Mountain Drive, Gotham",
  },
];
export const orderInputs = [
  {
    id: "customer",
    label: "Customer_name",
    type: "text",
    placeholder: "firstname_lastname",
  },
  {
    id: "product",
    label: "Product",
    type: "text",
    placeholder: "product_name",
  },
  {
    id: "orderDate",
    label: "Order Date",
    type: "date",
    placeholder: "select a date",
  },
  {
    id: "amount",
    label: "Amount",
    type: "number",
    placeholder: 0,
  },
  {
    id: "paymentMethod",
    label: "Payment Method",
    type: "text",
    placeholder: "Online Mode or Cash on Delivery",
  },
];

export const productInputs = [
  {
    id: "title",
    label: "Title",
    type: "text",
    placeholder: "Apple Macbook Pro",
  },
  {
    id: "description",
    label: "Description",
    type: "text",
    placeholder: "Description",
  },
  {
    id: "category",
    label: "Category",
    type: "text",
    placeholder: "Computers",
  },
  {
    id: "price",
    label: "Price",
    type: "text",
    placeholder: "100",
  },
  {
    id: "quantity",
    label: "Quantity",
    type: "text",
    placeholder: "50",
  },
];
